export default "__VITE_ASSET__40b77ce0__"